import { buildProps, definePropType } from '@ll-plus/utils'
import { UploadProps as AntUploadProps } from 'ant-design-vue'
import type { FileType } from 'ant-design-vue/es/upload/interface'
import { ExtractPropTypes } from 'vue'
import type Upload from './upload.vue'

export const operateStyle = ['button', 'drag', 'card'] as const
export const listType = ['text', 'picture', 'picture-card'] as const

export const uploadProps = buildProps({
  fileList: {
    type: definePropType<FileType[]>(Array),
    default: () => ([]),
  },

  // 是否禁用
  disabled: {
    type: Boolean,
    default: false,
  },

  // 操作风格
  operateStyle: {
    type: String,
    values: operateStyle,
    default: 'drag',
  },

  // 操作风格
  listType: {
    type: String,
    values: listType,
    default: 'text',
  },

  // 上传图标
  uploadIcon: {
    type: String,
    default: 'icon-add',
  },
  // 上传图标大小
  uploadIconSize: {
    type: Number,
    default: 24,
  },

  // 上传标题
  uploadTitle: {
    type: String,
    default: '',
  },

  // 上传描述
  uploadTip: {
    type: String,
    default: '',
  },

  accept: {
    type: String,
    default: 'image/*',
  },
  imgSize: {
    type: Number,
    default: 2,
  },

  beforeUpload: {
    type: definePropType<AntUploadProps['beforeUpload']>(Function),
    default: () => true,
  },
})

// props
export type UploadProps = ExtractPropTypes<typeof uploadProps>

// instance
export type UploadInstance = InstanceType<typeof Upload>
